
import { Dropdown } from 'primereact/dropdown'
import { useUserMappingWithBranch } from '../../../Hooks/Features/Overview/useUserMappingWithBranch'
import { MultiSelect } from 'primereact/multiselect'
import PanelHeaderTemplate from '../../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog'
import { SkeletonDataTable } from '../../Loader/Loader'
import { AgGridReact } from '@ag-grid-community/react'

const UserMappingWithBranch = () => {
    const { options, formValues, setFormValues, upsertMapping, confirmationPopup, setConfirmationPopup, HandleDeleteMapping, loader, columnDefs, rowData } = useUserMappingWithBranch()
    return (
        <div>
            <div className='row'>
                <div className="col-md-5 col-12">
                    <MultiSelect
                        onChange={(e) => { setFormValues((prev) => ({ ...prev, users: e.target.value })) }}
                        options={options?.allUser}
                        filter
                        filterInputAutoFocus
                        placeholder="Users"
                        value={formValues?.users}
                        optionLabel="user_display_name"
                        className="input-dd"
                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'users', formValues.users, (val) => setFormValues((prev) => ({ ...prev, users: val })), () => { })} />
                </div>
                <div className='col-md-5 col-12'>
                    <Dropdown
                        onChange={(e) => setFormValues((prev) => ({ ...prev, group_id: e.target.value, isChange: true }))}
                        options={options?.groups}
                        placeholder="Unit"
                        value={formValues?.group_id}
                        optionLabel="group_name"
                        filter
                        filterInputAutoFocus
                        className="input-dd"
                    />
                </div>
                <div className='col-md-2 col-12'>
                    <button className='btn-defult' onClick={upsertMapping}><FontAwesomeIcon icon="fa-solid fa-add" /></button>
                </div>
            </div>
            <hr>
            </hr>
            {
                loader ? <SkeletonDataTable numSkeletons={10} /> : <div className="ag-theme-alpine my-2" style={{ height: "50vh", width: '100%' }}>
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        rowHeight={40}
                        headerHeight={30}
                    />
                </div>
            }
            <CommanDialog visible={confirmationPopup?.show} handleClose={() => setConfirmationPopup({ show: false, id: "" })} handleFun={HandleDeleteMapping} message="Are you sure you want to delete this mapping?" />
        </div>
    )
}

export default UserMappingWithBranch